import React, { useState, useEffect } from "react";

import { useTranslation } from "react-i18next";
import { cloneDeep } from "lodash";

import ActionButtonLayout from "../layout/ActionButtonLayout";
import CustomFormDialog from "../dialogTypes/CustomFormDialog";

function MomSysCustomerSupplyInputDoInputButton(props) {
    const { id, schema, grid, refresh, onSuccess, onFailure, customizeErrorMsgCallback, ...others } = props;

    const { t } = useTranslation();

    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState();

    const [modifiedSchema, setModifiedSchema] = useState();

    useEffect(() => {
        let modifiedSchema = cloneDeep(schema);

        if (modifiedSchema) {
            for (const column of modifiedSchema.columns) {
                switch (column.name) {
                    case "wareHouseCode":
                        column.hideInForm = false;
                        column.required = true;

                        break;
                    case "inPrice":
                        column.hideInForm = false;
                        column.required = true;

                        break;
                    case "inAmount":
                        column.hideInForm = false;
                        column.required = true;

                        break;
                    default:
                        column.disabled = true;
                        column.required = false;
                        break;
                }
            }

            modifiedSchema.columns.push({
                name: "inputDate",
                type: "DATETIME(6)",
                nullable: "NO",
                required: false,
                default: null,
                formGroup: 1,
                formOrder: 210,
                formItemType: "date",
            })

            setModifiedSchema(modifiedSchema);
        }
    }, [schema]);

    const onOpen = () => {
        if (grid) {
            setFormData({ ...grid.selectedItems[0], extLotNo: "extLot" });
        }

        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onInputSuccess = (msg) => {
        if (onSuccess) {
            onSuccess(msg);
        }

        if (refresh) {
            refresh.refresh();
        }
    };

    return (
        <React.Fragment>
            <ActionButtonLayout id={id} onClick={onOpen} {...others}>
                {t("buttonName.input")}
            </ActionButtonLayout>
            <CustomFormDialog
                id={id + "-input-dialog"}
                mode="edit"
                formId={id + "-input-form"}
                title={schema ? t(`dialog.title.${schema.name}.input`) : ""}
                schema={modifiedSchema}
                modifyUrlCallback={(url) => `/api/MomSysCustomerSupplyInput/doInput`}
                initialData={formData}
                open={open}
                onClose={onClose}
                onSuccess={onInputSuccess}
                customizeErrorMsgCallback={customizeErrorMsgCallback}
                buttonLabel={[t("buttonName.input"), t("common.cancel")]}
                modifyFormDataCallback={(formData, name) => {
                    if (name === "qtyInput" || name === "inPrice") {
                        formData.inAmount = formData.qtyInput * formData.inPrice;
                    }
                }}
            />
        </React.Fragment>
    );
}

export default MomSysCustomerSupplyInputDoInputButton;
